__turbopack_context__.v({
  "homeIntroSection": "home-intro-section-module-scss-module__bL8uqa__homeIntroSection",
  "homeIntroSection_content": "home-intro-section-module-scss-module__bL8uqa__homeIntroSection_content",
  "homeIntroSection_search": "home-intro-section-module-scss-module__bL8uqa__homeIntroSection_search",
  "homeIntroSection_stats": "home-intro-section-module-scss-module__bL8uqa__homeIntroSection_stats",
  "homeIntroSection_wrapper": "home-intro-section-module-scss-module__bL8uqa__homeIntroSection_wrapper",
});
